import { AuthActionTypes, AuthState } from './types';
import { AnyAction } from 'redux';

export const initialAuthState: AuthState = {
	auth: {
		accessToken: '',
	},
};

const reducer: (state: AuthState | undefined, action: AnyAction) => AuthState = (
	state = initialAuthState,
	action
): AuthState => {
	// eslint-disable-next-line sonarjs/no-small-switch
	switch (action.type) {
		case AuthActionTypes.FETCH_PROCESS_TOKEN_SUCCESS: {
			return {
				...state,
				auth: {
					...state.auth,
					accessToken: action.payload as string,
				},
			};
		}
		default: {
			return state;
		}
	}
};

export { reducer as authReducer };
